// Components
import Driver from "../Components/Driver";
import User from "../Components/Users";
import DriverRides from "../Components/DriverRides";
import UserRide from "../Components/UserRide";
import Dashboard from "../Components/Dashboard";
import Chat from "../Components/Chat";
import ChatList from "../Components/Chat/ChatList";

export const routes = [
  //dashboard
  { path: `/`, Component: <Dashboard /> },
  { path: `/drivers`, Component: <Driver /> },
  { path: `/driver-rides`, Component: <DriverRides /> },
  { path: `/users`, Component: <User /> },
  { path: `/user-chat/:id`, Component: <Chat /> },
  { path: `/user-rides`, Component: <UserRide /> },
  { path: `/chats`, Component: <ChatList /> },
];
